import { render, staticRenderFns } from "./contract-detail-paper-nganluong.vue?vue&type=template&id=1fb5c70a&scoped=true"
import script from "./contract-detail-paper-nganluong.vue?vue&type=script&lang=js"
export * from "./contract-detail-paper-nganluong.vue?vue&type=script&lang=js"
import style0 from "./contract-detail-paper-nganluong.vue?vue&type=style&index=0&id=1fb5c70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5c70a",
  null
  
)

export default component.exports